import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config";

// pricing rate request
export const fetchPricingLeadStatusRequest = () => ({
    type: "FIND_PRICING_LEAD_STATUS_REQUEST",
});

export const fetchPricingLeadStatusSuccess = (data) => ({
    type: "FIND_PRICING_LEAD_STATUS_SUCCESS",
    payload: data,
});

export const fetchPricingLeadStatusFailure = (error) => ({
    type: "FIND_PRICING_LEAD_STATUS_FAILURE",
    payload: error,
});

export const getPricingLeadStatus = (token, user_id, identifier, current_page, queryParams) => {
    return async function (dispatch) {
        dispatch(fetchPricingLeadStatusRequest());

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            destination: "",
            email: "",
            end_date: null,
            name: "",
            origin: "",
            phone: "",
            request_no: "",
            required_servie_id: "",
            search_by: "",
            shipment_type_id: "",
            shipment_via_id: "",
            start_date: null,
            assign_branch_id: "",
        };
        params.forEach((value, key) => {
            requestBody[key] = value;
        });

        if (requestBody.assign_branch_id && !requestBody.branch_id) {
            requestBody.branch_id = requestBody.assign_branch_id;
        }
        if (requestBody.branch_id && !requestBody.assign_branch_id) {
            requestBody.assign_branch_id = requestBody.branch_id;
        }

        let midURL = '';

        if (identifier == "air-import-requested") { midURL = "pricing/requested-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "air-import-my-quotes") { midURL = "pricing/my-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "air-import-inprocess") { midURL = "pricing/inprocess-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "air-import-sent") { midURL = "pricing/sent-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "air-import-repricing") { midURL = "pricing/repricing-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "IMPORTER" }

        if (identifier == "air-export-requested") { midURL = "pricing/requested-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "air-export-my-quotes") { midURL = "pricing/my-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "air-export-inprocess") { midURL = "pricing/inprocess-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "air-export-sent") { midURL = "pricing/sent-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "air-export-repricing") { midURL = "pricing/repricing-quote-list"; requestBody.shipment_mode = "air"; requestBody.quotation_user_type = "EXPORTER" }


        if (identifier == "ocean-import-requested") { midURL = "pricing/requested-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "ocean-import-my-quotes") { midURL = "pricing/my-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "ocean-import-inprocess") { midURL = "pricing/inprocess-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "ocean-import-sent") { midURL = "pricing/sent-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "ocean-import-repricing") { midURL = "pricing/repricing-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "IMPORTER" }

        if (identifier == "ocean-export-requested") { midURL = "pricing/requested-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "ocean-export-my-quotes") { midURL = "pricing/my-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "ocean-export-inprocess") { midURL = "pricing/inprocess-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "ocean-export-sent") { midURL = "pricing/sent-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "ocean-export-repricing") { midURL = "pricing/repricing-quote-list"; requestBody.shipment_mode = "ocean"; requestBody.quotation_user_type = "EXPORTER" }


        if (identifier == "courier-import-requested") { midURL = "pricing/requested-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "courier-import-my-quotes") { midURL = "pricing/my-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "courier-import-inprocess") { midURL = "pricing/inprocess-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "courier-import-sent") { midURL = "pricing/sent-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "IMPORTER" }
        if (identifier == "courier-import-repricing") { midURL = "pricing/repricing-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "IMPORTER" }

        if (identifier == "courier-export-requested") { midURL = "pricing/requested-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "courier-export-my-quotes") { midURL = "pricing/my-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "courier-export-inprocess") { midURL = "pricing/inprocess-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "courier-export-sent") { midURL = "pricing/sent-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "EXPORTER" }
        if (identifier == "courier-export-repricing") { midURL = "pricing/repricing-quote-list"; requestBody.shipment_mode = "courier"; requestBody.quotation_user_type = "EXPORTER" }



        params.delete('page');  // Remove the page from the query params

        let config = {
            method: "POST",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        };
        if (!current_page) {
            current_page = 1;
        }


        let apiUrl = `${adminMainUrl}/api/${midURL}?page=${current_page}`

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchPricingLeadStatusSuccess(resData));
                });
            }).catch((err) => {
                console.log("ERROR in getPricingLeadStatus function(redux):", err);
                fetchPricingLeadStatusFailure(err.message);
            });
    };
};

// picked rate request


//get Quotation/Lead Info

// export const fetchQuoteDetailRequest = () => ({
//     type: "FIND_QUOTE_DETAIL_REQUEST",
// });

// export const fetchQuoteDetailSuccess = (data) => ({
//     type: "FIND_QUOTE_DETAIL_SUCCESS",
//     payload: data,
// });

// export const fetchQuoteDetailFailure = (error) => ({
//     type: "FIND_QUOTE_DETAIL_FAILURE",
//     payload: error,
// });

// export const getQuoteDetail = (token, id) => {
//     return async function (dispatch) {
//         dispatch(fetchQuoteDetailRequest());
//         let config = {
//             method: "POST",
//             headers: {
//                 'Content-Type': 'application/json',
//                 'auth-token': token
//             },
//             body: JSON.stringify({ quotation_id: id })
//         };
//         await fetch(`${adminMainUrl}/api/quotation/view`, config)
//             .then((res) => {
//                 res.json().then((resData) => {
//                     dispatch(fetchQuoteDetailSuccess(resData.data));
//                 })
//             }).catch((err) => {
//                 dispatch(fetchQuoteDetailFailure(err.message));
//                 console.log("ERROR in getQuoteDetail function(redux):", err);
//             });
//     };
// };


//get Quotation/Lead Info


//get Pricing Quotation/Lead Info

// export const fetchPricingQuoteDetailRequest = () => ({
//     type: "FIND_PRICING_QUOTE_DETAIL_REQUEST",
// });

// export const fetchPricingQuoteDetailSuccess = (data) => ({
//     type: "FIND_PRICING_QUOTE_DETAIL_SUCCESS",
//     payload: data,
// });

// export const fetchPricingQuoteDetailFailure = (error) => ({
//     type: "FIND_PRICING_QUOTE_DETAIL_FAILURE",
//     payload: error,
// });

// export const getPricingQuoteDetail = (token, id) => {
//     return async function (dispatch) {
//         dispatch(fetchPricingQuoteDetailRequest());
//         let config = {
//             method: "POST",
//             headers: {
//                 'Content-Type': 'application/json',
//                 'auth-token': token
//             },
//             body: JSON.stringify({ quotation_id: id })
//         };
//         await fetch(`${adminMainUrl}/api/pricing/view`, config)
//             .then((res) => {
//                 res.json().then((resData) => {
//                     dispatch(fetchPricingQuoteDetailSuccess(resData.data));
//                 })
//             }).catch((err) => {
//                 dispatch(fetchPricingQuoteDetailFailure(err.message));
//                 console.log("ERROR in getPricingQuoteDetail function(redux):", err);
//             });
//     };
// };


//get Pricing Quotation/Lead Info


